import { Divider } from '@mui/material';
import React from 'react';
import './CountrySelect.css';

const CountryContainer = () => {
  const handleCountrySelect = (event) => {
    const selectedCountry = event.target.value;
    console.log(`Selected country: ${selectedCountry}`);
    // Add your logic here to handle the selected country
  };
  const middleEastList = [
    { name: 'India', link: '/in', enable: true },
    { name: 'South Africa', link: '/in', enable: false },
    { name: 'Oman', link: '/in', enable: false },
    { name: 'UAE', link: '/in', enable: false },
    { name: 'Qatar', link: '/in', enable: false },
  ];
  const asiaPacificList = [
    { name: 'Australia', link: '/in', enable: false },
    { name: 'Thailand', link: '/th', enable: false },
    { name: 'Japan', link: '/jp', enable: false },
    { name: 'Malaysia', link: '/my', enable: true },
    { name: 'Philippines', link: '/in', enable: false },
    { name: 'New Zeland', link: '/in', enable: false },
    { name: 'Indonesia', link: '/id', enable: false },
    { name: 'Singapore', link: '/in', enable: false },
  ];
  const europeList = [
    { name: 'United Kingdom', link: '/in', enable: false },
    { name: 'Germany', link: '/in', enable: false },
    { name: 'France', link: '/in', enable: false },
    { name: 'Italy', link: '/in', enable: false },
    { name: 'Spain', link: '/in', enable: false },
    { name: 'Netherlands', link: '/in', enable: false },
    { name: 'Ireland', link: '/in', enable: false },
    { name: 'Turkey', link: '/in', enable: false },
    { name: 'Portugal ', link: '/in', enable: false },
  ];
  return (
    <section className="countrySection">
      <div className="country-section">
        <p>Select your Country or region</p>

        <Divider className="divider-class" />
        <div>
          <h6>Africa, Middle East & India</h6>
          <div className="country-select-container">
            {middleEastList.map((country, index) => (
              <div key={index}>
                <a
                  aria-label=""
                  href={country?.link}
                  style={{
                    pointerEvents: country?.enable ? 'auto' : 'none',
                    opacity: country?.enable ? 1 : 0.5,
                    cursor: country?.enable && 'pointer',
                    color: country?.enable ? 'rgb(0, 60, 197)' : 'gray',
                  }}
                  disabled={country?.enable}
                >
                  {country?.name}
                </a>
              </div>
            ))}
          </div>
        </div>
        <Divider className="divider-class" />
        <div>
          <h6>Asia Pacific</h6>
          <div className="country-select-container">
            {asiaPacificList.map((country, index) => (
              <div key={index}>
                <a
                  aria-label=""
                  href={country?.link}
                  style={{
                    pointerEvents: country?.enable ? 'auto' : 'none',
                    opacity: country?.enable ? 1 : 0.5,
                    cursor: country?.enable && 'pointer',
                    color: country?.enable ? 'rgb(0, 60, 197)' : 'gray',
                  }}
                  disabled={country?.enable}
                >
                  {country?.name}
                </a>
              </div>
            ))}
          </div>
        </div>
        <Divider className="divider-class" />
        <div>
          <h6>Europe</h6>
          <div className="country-select-container">
            {europeList.map((country, index) => (
              <div key={index}>
                <a
                  aria-label=""
                  href={country?.link}
                  style={{
                    pointerEvents: country?.enable ? 'auto' : 'none',
                    opacity: country?.enable ? 1 : 0.5,
                    cursor: country?.enable && 'pointer',
                    color: country?.enable ? 'rgb(0, 60, 197)' : 'gray',
                  }}
                  disabled={country?.enable}
                >
                  {country?.name}
                </a>
              </div>
            ))}
          </div>
        </div>
        <Divider className="divider-class" />
      </div>
    </section>
  );
};

export default CountryContainer;
